import React from "react";
import { ImPointRight } from "react-icons/im";
function AboutCard() {
  return (
    <div className="quote-card-view">
      <div>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone,
            <br /> I am <strong className="">Sabal Subedi</strong>, originally
            from <strong>Kathmandu, Nepal</strong>, and currently living in{" "}
            <strong>Pocatello, Idaho</strong>.
            <br />
            <strong>
              Software Engineer | AI/ML Enthusiast | Full-Stack Developer
            </strong>
            <br />
            I love building things that matter—whether it’s crafting seamless
            web experiences or diving into AI-driven problem-solving. With a
            strong foundation in full-stack web development and AI/ML, I build
            scalable, efficient, and user-friendly applications, leveraging
            React.js, JavaScript, TypeScript, Node.js, Flask, and ML frameworks
            like TensorFlow and PyTorch.
            <br />
            Passionate about problem-solving, collaboration, and innovation, I
            thrive at the intersection of software development and AI research,
            always eager to create impactful solutions.
            <br />
            <br />
            Some of my favorite activities beyond coding!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight className="activity-pointer" /> Playing Soccer and
              Basketball
            </li>
            <li className="about-activity">
              <ImPointRight className="activity-pointer" /> Playing Games
            </li>
            <li className="about-activity">
              <ImPointRight className="activity-pointer" /> Travelling
            </li>
            <li className="about-activity">
              <ImPointRight className="activity-pointer" /> Watching Movies
            </li>
          </ul>
        </blockquote>
      </div>
    </div>
  );
}

export default AboutCard;
